var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "app-grid-item",
        {
          attrs: {
            "edit-mode": _vm.editMode,
            item: _vm.item,
            state: _vm.state,
          },
        },
        [
          _c(_vm.tag, {
            ref: "component",
            tag: "component",
            attrs: { item: _vm.item, "edit-mode": _vm.editMode },
          }),
          _c(
            "transition",
            {
              attrs: { slot: "buttons-container", name: "fade" },
              slot: "buttons-container",
            },
            [
              _vm.editMode
                ? _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _vm.hasSettings
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.edit-settings"),
                                  expression: "$ct('common.edit-settings')",
                                },
                              ],
                              staticClass: "round mr sm",
                              on: {
                                click: function ($event) {
                                  return _vm.openSettings()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.remove-item"),
                              expression: "$ct('common.remove-item')",
                            },
                          ],
                          staticClass: "round danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeSelf()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }